// src/pages/admin/AdminHome.jsx
import React from "react";
import { Link } from "react-router-dom";

export default function AdminHome() {
  const card = {
    base: {
      border: "1px solid #e5e7eb",
      borderRadius: 12,
      background: "#fff",
      padding: 16,
      boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
    },
    title: { fontSize: 16, fontWeight: 800, marginBottom: 6 },
    text: { color: "#374151", fontSize: 14 },
    btn: {
      display: "inline-block",
      marginTop: 10,
      padding: "8px 12px",
      borderRadius: 10,
      border: "1px solid #0ea5e9",
      background: "#0ea5e9",
      color: "#fff",
      fontWeight: 700,
    },
  };

  return (
    <section style={{ maxWidth: 1080, margin: "0 auto", padding: "0 16px" }}>
      <h2 style={{ margin: "0 0 12px", fontSize: 22, fontWeight: 800 }}>
        後台首頁
      </h2>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
          gap: 12,
        }}
      >
        <div style={card.base}>
          <div style={card.title}>公告管理</div>
          <div style={card.text}>新增 / 編輯 / 下架公告與衛教文章。</div>
          <Link to="/admin/notice" style={card.btn}>
            前往
          </Link>
        </div>

        <div style={card.base}>
          <div style={card.title}>班表管理</div>
          <div style={card.text}>以月曆表格方式維護每日早午晚醫師。</div>
          <Link to="/admin/schedule" style={card.btn}>
            前往
          </Link>
        </div>

        <div style={card.base}>
          <div style={card.title}>門診預約名單</div>
          <div style={card.text}>查詢某日某時段名單並下載 CSV。</div>
          <Link to="/admin/slot" style={card.btn}>
            前往
          </Link>
        </div>
      </div>
    </section>
  );
}
